import { useNavigate, To } from 'react-router-dom';
import { Button, enqueueSnackbar } from '../../design-system';
import {
  ErrorSection,
  SectionName,
  SectionHeading,
  SectionSubHeading,
  SectionFooter,
} from './ErrorComponents';
import { i18n } from '../../i18n';
import { MESSAGES } from '../../const/messages';
import { authService } from '../../services';

interface ErrorPageProps {
  heading: string;
  detail: string;
  navigateTo: string | number;
  resetError?: () => void;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({
  heading,
  detail,
  navigateTo,
  resetError,
}: ErrorPageProps) => {
  const navigate = useNavigate();

  const handleLogoutClick = async () => {
    await authService.logout();
    enqueueSnackbar(MESSAGES.AUTH.SUCCESS.LOG_OUT, 'success');
    resetError && resetError();
    navigate('/signin');
  };

  const handleTakeBack = () => {
    resetError && resetError();
    navigate(navigateTo as To);
  };

  return (
    <>
      <ErrorSection>
        <SectionName align={'center'}>{i18n.t('pages.error.title')}</SectionName>
        <SectionHeading align={'center'}>{heading}</SectionHeading>
        <SectionSubHeading align={'center'}>{detail}</SectionSubHeading>
        <SectionFooter>
          <Button
            variant={'contained'}
            size={'large'}
            data-color={'destructive'}
            onClick={handleLogoutClick}
          >
            {i18n.t('button.logOut')}
          </Button>
          <Button variant={'contained'} size={'large'} onClick={handleTakeBack}>
            {i18n.t('button.takeMeBack')}
          </Button>
        </SectionFooter>
      </ErrorSection>
    </>
  );
};
